import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view, {
      class: "view",
      "keep-alive": "",
      transition: "",
      "transition-mode": "out-in"
    })
  ]))
}